class GaranPopup extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector('[data-garan-modal]');
    this.image = this.querySelector('[data-garan-image]');
    this.onTriggerClick = this.onTriggerClick.bind(this);
    document.addEventListener('click', this.onTriggerClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onTriggerClick);
  }

  onTriggerClick(event) {
    const trigger = event.target.closest('[data-garan-open]');
    if (!trigger) return;

    const src = trigger.getAttribute('data-garan-src');
    if (!src || !this.modal) return;

    event.preventDefault();

    if (this.image) {
      this.image.src = src;
      this.image.alt = trigger.getAttribute('data-garan-alt') || '';
      this.image.hidden = false;
    }

    this.modal.show(trigger);
  }
}

if (!customElements.get('garan-popup')) {
  customElements.define('garan-popup', GaranPopup);
}
